export default __webpack_public_path__ + "static/media/gh_checks.33049246.png";